import React from 'react';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';

import { ButtonText, ButtonIcon } from '../buttons';

const StyledButton = styled(Button)`
        &.stolo-button-secondary{
                position: relative;
                ${props => props.theme.typography.button};
                display: inline-flex;
                align-items: center;
                height: 100%;
                width: 100%;
                background-color: ${props => props.theme.palette.secondary.main};
                color: white;
                text-align: center;
                margin: ${props => props.theme.space[8]} 0;
                padding: ${props => props.theme.space[4]} ${props => props.theme.space[6]}};
                line-height: 1;
                &:hover {
                  background-color: ${props => props.theme.palette.secondary[400]};
                }
        }
  
         & {
          padding: 0.25em;
        }
    `;


const SecondaryFlatButton = ({ text, icon, handleClick, ...props }) => {
    const Icon = icon ? <ButtonIcon icon={icon} iconColor={'common.white'} /> : null;
    return (
        <StyledButton classes={{ flatSecondary: 'stolo-button-secondary' }} color='secondary' variant='flat' onClick={handleClick} {...props}>
            {Icon}
            <ButtonText buttonText={text} />
        </StyledButton>
    );
};


export default SecondaryFlatButton;



// WEBPACK FOOTER //
// ./src/components/buttons/SecondaryFlatButton.js